module.exports = __webpack_public_path__ + "static/media/helsinki-6.9afd5ae8.jpg";